import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ChartOrderBookData from 'pages/Entrepeneur/Feedbacks/charts/ChartOrderBookData';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 400,
    minHeight: 250,
    marginTop: '1.5rem'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: 17,
    fontFamily: 'PT Serif',
    color: '#001E41',
    fontWeight: 'bold'
  },
  dropDown: {
    textAlign: 'right',
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  details: {
    fontFamily: 'PT sans',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#002380',
    cursor: 'pointer'
  },
  data: {
    marginTop: '1rem',
    textAlign: 'center'
  },
  formControl: {
    minWidth: 90
  },
  selectContainer: {
    textAlign: 'right'
  },
  select: {
    borderRadius: '7px',
    '& .MuiOutlinedInput-input': {
      padding: '9.5px 13px'
    }
  }
}));

const OrderBook = () => {
  const classes = useStyles();
  const [month, setMonth] = useState('');

  const handleChangeMonth = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
  };

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <div className={classes.container}>
          <Typography className={classes.title} gutterBottom>
            Order Book
          </Typography>
          <Typography className={classes.details} gutterBottom>
            See details
          </Typography>
        </div>
        <div className={classes.selectContainer}>
          <FormControl className={classes.formControl} variant="outlined">
            <Select
              className={classes.select}
              inputProps={{
                name: 'month',
                id: 'month'
              }}
              native
              onChange={handleChangeMonth}
              value={month}>
              <option value="March 8">March 8</option>
              <option value="April 8">April 8</option>
              <option value="May 8">May 8</option>
              <option value="June 8">June 8</option>
            </Select>
          </FormControl>
        </div>
        <ChartOrderBookData />
        {/* <Typography className={classes.data} component="h3" variant="h3">
          Data
          <br />
          visualisation
        </Typography> */}
        <hr
          style={{
            width: '100%',
            margin: '1rem auto',
            color: '#D8D8D8',
            opacity: '0.3'
          }}
        />
      </CardContent>
    </Card>
  );
};

export default OrderBook;
